import React from 'react'
import About from '../assets/f1/about.png'
import '../styles/about.css'
import Team from '../assets/images/aboutimg.jpg'
import { Container, Row, Col } from "react-bootstrap";
import CountUp from "react-countup";
import AOS from "aos";
import "aos/dist/aos.css";
import PeopleAltIcon from '@mui/icons-material/PeopleAlt';
import feture1 from '../assets/f1/feature-1.png';
import feture2 from '../assets/f1/feature-2.png';


export default function blog() {
    return (
        <div>
            <section className="bg-white dark:bg-gray-900">
                <div className="grid max-w-screen-xl px-4 pt-20 pb-8 mx-auto lg:gap-8 xl:gap-0 lg:py-16 lg:grid-cols-12 lg:pt-28">
                    <div className="mr-auto place-self-center lg:col-span-7">
                        <h1 className="max-w-2xl mb-4 text-4xl font-extrabold leading-none tracking-tight md:text-5xl xl:text-6xl dark:text-white">About Us title</h1>
                        <p className="max-w-2xl mb-6 font-light text-gray-500 lg:mb-8 md:text-lg lg:text-xl dark:text-gray-400"><h6>about us description</h6>Lorem ipsum dolor sit amet consectetur adipisicing elit. Similique rem, neque itaque ea quam minima sed fugiat, odio quisquam obcaecati repellat et voluptatibus amet debitis. Consequuntur neque maiores libero minus!.</p>
                        <div className="space-y-4 sm:flex sm:space-y-0 sm:space-x-4">
                            <a href="https://github.com/themesberg/landwind" className="inline-flex items-center justify-center w-full px-5 py-3 text-sm font-medium text-center text-gray-900 border border-gray-200 rounded-lg sm:w-auto hover:bg-gray-100 focus:ring-4 focus:ring-gray-100 dark:text-white dark:border-gray-700 dark:hover:bg-gray-700 dark:focus:ring-gray-800">
                                <svg className="w-4 h-4 mr-2 text-gray-500 dark:text-gray-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 496 512"><path d="M165.9 397.4c0 2-2.3 3.6-5.2 3.6-3.3.3-5.6-1.3-5.6-3.6 0-2 2.3-3.6 5.2-3.6 3-.3 5.6 1.3 5.6 3.6zm-31.1-4.5c-.7 2 1.3 4.3 4.3 4.9 2.6 1 5.6 0 6.2-2s-1.3-4.3-4.3-5.2c-2.6-.7-5.5.3-6.2 2.3zm44.2-1.7c-2.9.7-4.9 2.6-4.6 4.9.3 2 2.9 3.3 5.9 2.6 2.9-.7 4.9-2.6 4.6-4.6-.3-1.9-3-3.2-5.9-2.9zM244.8 8C106.1 8 0 113.3 0 252c0 110.9 69.8 205.8 169.5 239.2 12.8 2.3 17.3-5.6 17.3-12.1 0-6.2-.3-40.4-.3-61.4 0 0-70 15-84.7-29.8 0 0-11.4-29.1-27.8-36.6 0 0-22.9-15.7 1.6-15.4 0 0 24.9 2 38.6 25.8 21.9 38.6 58.6 27.5 72.9 20.9 2.3-16 8.8-27.1 16-33.7-55.9-6.2-112.3-14.3-112.3-110.5 0-27.5 7.6-41.3 23.6-58.9-2.6-6.5-11.1-33.3 2.6-67.9 20.9-6.5 69 27 69 27 20-5.6 41.5-8.5 62.8-8.5s42.8 2.9 62.8 8.5c0 0 48.1-33.6 69-27 13.7 34.7 5.2 61.4 2.6 67.9 16 17.7 25.8 31.5 25.8 58.9 0 96.5-58.9 104.2-114.8 110.5 9.2 7.9 17 22.9 17 46.4 0 33.7-.3 75.4-.3 83.6 0 6.5 4.6 14.4 17.3 12.1C428.2 457.8 496 362.9 496 252 496 113.3 383.5 8 244.8 8zM97.2 352.9c-1.3 1-1 3.3.7 5.2 1.6 1.6 3.9 2.3 5.2 1 1.3-1 1-3.3-.7-5.2-1.6-1.6-3.9-2.3-5.2-1zm-10.8-8.1c-.7 1.3.3 2.9 2.3 3.9 1.6 1 3.6.7 4.3-.7.7-1.3-.3-2.9-2.3-3.9-2-.6-3.6-.3-4.3.7zm32.4 35.6c-1.6 1.3-1 4.3 1.3 6.2 2.3 2.3 5.2 2.6 6.5 1 1.3-1.3.7-4.3-1.3-6.2-2.2-2.3-5.2-2.6-6.5-1zm-11.4-14.7c-1.6 1-1.6 3.6 0 5.9 1.6 2.3 4.3 3.3 5.6 2.3 1.6-1.3 1.6-3.9 0-6.2-1.4-2.3-4-3.3-5.6-2z" /></svg> View on GitHub
                            </a>
                            <a href="https://www.figma.com/community/file/1125744163617429490" className="inline-flex items-center justify-center w-full px-5 py-3 mb-2 mr-2 text-sm font-medium text-gray-900 bg-white border border-gray-200 rounded-lg sm:w-auto focus:outline-none hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-4 focus:ring-gray-200 dark:focus:ring-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:border-gray-600 dark:hover:text-white dark:hover:bg-gray-700">
                                <button classNameName="flex items-center p-2 bg-blue-500 text-white rounded">
                                    <svg
                                        classNameName="w-4 h-4 mr-2"
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 200 300"
                                        width="16"
                                        height="24"
                                    >
                                        <style>
                                            {`
                                        .st0 { fill: #0acf83; }
                                        .st1 { fill: #a259ff; }
                                        .st2 { fill: #f24e1e; }
                                        .st3 { fill: #ff7262; }
                                        .st4 { fill: #1abcfe; }
                                    `}
                                        </style>
                                        <title>Figma.logo</title>
                                        <desc>Created using Figma</desc>
                                        <path classNameName="st0" d="M50 300c27.6 0 50-22.4 50-50v-50H50c-27.6 0-50 22.4-50 50s22.4 50 50 50z" />
                                        <path classNameName="st1" d="M0 150c0-27.6 22.4-50 50-50h50v100H50c-27.6 0-50-22.4-50-50z" />
                                        <path classNameName="st2" d="M0 50C0 22.4 22.4 0 50 0h50v100H50C22.4 100 0 77.6 0 50z" />
                                        <path classNameName="st3" d="M100 0h50c27.6 0 50 22.4 50 50s-22.4 50-50 50h-50V0z" />
                                        <path classNameName="st4" d="M200 150c0 27.6-22.4 50-50 50s-50-22.4-50-50 22.4-50 50-50 50 22.4 50 50z" />
                                    </svg>
                                    Get Figma file
                                </button>
                                {/* <svg className="w-4 h-4 mr-2" id="Layer_1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 300" width="1667" height="2500"><style type="text/css">.st0{fill:#0acf83}.st1{fill:#a259ff}.st2{fill:#f24e1e}.st3{fill:#ff7262}.st4{fill:#1abcfe}</style><title>Figma.logo</title><desc>Created using Figma</desc><path id="path0_fill" className="st0" d="M50 300c27.6 0 50-22.4 50-50v-50H50c-27.6 0-50 22.4-50 50s22.4 50 50 50z"/><path id="path1_fill" className="st1" d="M0 150c0-27.6 22.4-50 50-50h50v100H50c-27.6 0-50-22.4-50-50z"/><path id="path1_fill_1_" className="st2" d="M0 50C0 22.4 22.4 0 50 0h50v100H50C22.4 100 0 77.6 0 50z"/><path id="path2_fill" className="st3" d="M100 0h50c27.6 0 50 22.4 50 50s-22.4 50-50 50h-50V0z"/><path id="path3_fill" className="st4" d="M200 150c0 27.6-22.4 50-50 50s-50-22.4-50-50 22.4-50 50-50 50 22.4 50 50z"/></svg> Get Figma file */}
                            </a>
                        </div>
                    </div>
                    <div className="hidd lg:mt-0 lg:col-span-5 lg:flex">
                        <img src={About} alt="" />
                    </div>
                    {/* <div classNameName="hidden lg:mt-0 lg:col-span-5 lg:flex">
                <img src={Hero} alt="heroimage"/>
            </div>                 */}
                </div>
            </section>
            {/* <!-- End block --> */}








            <section className="bg-gray-50 dark:bg-gray-800">
                <div className="max-w-screen-xl px-4 py-8 mx-auto space-y-12 lg:space-y-20 lg:py-24 lg:px-6">
                    {/* <!-- Row --> */}
                    
                    {/* <!-- Row --> */}
                    <div className="items-center gap-8 lg:grid lg:grid-cols-2 xl:gap-16">
                        {/* <img className="hidden w-full mb-4 rounded-lg lg:mb-0 lg:flex" src={feture2} alt="featureimage2" /> */}
                        <div className='experetions'>
                        <h1 id='expe' className="mb-0  font-extrabold tracking-tight text-gray-900 dark:text-white">10</h1>
                        <br />
                        <h5>year Expereance </h5>
                        </div>
                        

                        <div className="text-gray-500 sm:text-lg dark:text-gray-400">
                            <h2 className="mb-4 text-3xl font-extrabold tracking-tight text-gray-900 dark:text-white">Our Core Value</h2>
                            <p className="mb-8 font-light lg:text-xl"><h6>company description</h6>Deliver great service experiences fast - without the complexity of traditional ITSM solutions. Accelerate critical development work, eliminate toil, and deploy changes with ease.</p>
                            {/* <!-- List --> */}
                            <ul /*role="list"*/ className="pt-8 space-y-5 border-t border-gray-200 my-7 dark:border-gray-700">
                                <li className="flex space-x-3">
                                    {/* <!-- Icon --> */}
                                    <svg className="flex-shrink-0 w-5 h-5 text-purple-500 dark:text-purple-400" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd"></path></svg>
                                    <span className="text-base font-medium leading-tight text-gray-900 dark:text-white">Dynamic reports and dashboards</span>
                                </li>
                                <li className="flex space-x-3">
                                    {/* <!-- Icon --> */}
                                    <svg className="flex-shrink-0 w-5 h-5 text-purple-500 dark:text-purple-400" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd"></path></svg>
                                    <span className="text-base font-medium leading-tight text-gray-900 dark:text-white">Templates for everyone</span>
                                </li>
                                <li className="flex space-x-3">
                                    {/* <!-- Icon --> */}
                                    <svg className="flex-shrink-0 w-5 h-5 text-purple-500 dark:text-purple-400" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd"></path></svg>
                                    <span className="text-base font-medium leading-tight text-gray-900 dark:text-white">Development workflow</span>
                                </li>
                                <li className="flex space-x-3">
                                    {/* <!-- Icon --> */}
                                    <svg className="flex-shrink-0 w-5 h-5 text-purple-500 dark:text-purple-400" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd"></path></svg>
                                    <span className="text-base font-medium leading-tight text-gray-900 dark:text-white">Limitless business automation</span>
                                </li>
                                <li className="flex space-x-3">
                                    {/* <!-- Icon --> */}
                                    <svg className="flex-shrink-0 w-5 h-5 text-purple-500 dark:text-purple-400" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd"></path></svg>
                                    <span className="text-base font-medium leading-tight text-gray-900 dark:text-white">Knowledge management</span>
                                </li>
                            </ul>
                            <p className="font-light lg:text-xl">Deliver great service experiences fast - without the complexity of traditional ITSM solutions.</p>
                        </div>
                    </div>
                </div>
            </section>
















            {/* <!-- start we are --> */}
            <section className='aboutWeAre bg-gray-50 dark:bg-gray-900 flex justify-center items-center min-h-screen mt-8'>
                <div className="text-center">
                    <h1 className=" weare max-w-2xl mb-4 text-4xl font-extrabold leading-none tracking-tight md:text-5xl xl:text-6xl dark:text-white">
                        We Are Synnex
                    </h1>
                </div>
            </section>
            <section className='team bg-gray-50 dark:bg-gray-900 flex justify-center items-center min-h-screen'>
                <div className=""><img className='teamimg' src={Team} alt="" /></div>
            </section>

            {/* <!-- End we are --> */}

            {/* <!-- Start block --> */}
            <section className="bg-white dark:bg-gray-900">
                <div className="items-center max-w-screen-xl px-4 py-8 mx-auto lg:grid lg:grid-cols-4 lg:gap-16 xl:gap-24 lg:py-24 lg:px-6">
                    <div className="col-span-2 mb-8">



                        <div className="card">
                            <a href="/">
                                <div className="flex flex-col max-w-lg p-6 mx-auto text-center text-gray-900 bg-white border border-gray-100 rounded-lg shadow dark:border-gray-600 xl:p-8 dark:bg-gray-800 dark:text-white">

                                    <h3 className="mb-4 text-2xl font-bold">Our Mission</h3>
                                    <p className="font-light text-gray-500 sm:text-lg dark:text-gray-400">
                                        Lorem ipsum dolor sit amet consectetur adipisicing elit. Similique rem, neque itaque ea quam minima sed fugiat, odio quisquam obcaecati repellat et voluptatibus amet debitis. Consequuntur neque maiores libero minus!.
                                    </p>


                                    <a href="/" className="text-white bg-purple-600 hover:bg-purple-700 focus:ring-4 focus:ring-purple-200 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:text-white  dark:focus:ring-purple-900">Get started</a>
                                </div>
                            </a>
                        </div>





                    </div>
                    <div className="col-span-2 space-y-8 md:grid md:grid-cols-2 md:gap-12 md:space-y-0">
                        <div className='col-span-2 mb-8'>
                            <div className="card">
                                <a href="/">
                                    <div className="flex flex-col max-w-lg p-6 mx-auto text-center text-gray-900 bg-white border border-gray-100 rounded-lg shadow dark:border-gray-600 xl:p-8 dark:bg-gray-800 dark:text-white">


                                        <h3 className="mb-4 text-2xl font-bold">Our Vision</h3>
                                        <p className="font-light text-gray-500 sm:text-lg dark:text-gray-400">
                                            Lorem ipsum dolor sit amet consectetur adipisicing elit. Similique rem, neque itaque ea quam minima sed fugiat, odio quisquam obcaecati repellat et voluptatibus amet debitis. Consequuntur neque maiores libero minus!.                                            </p>

                                        <a href="/" className="text-white bg-purple-600 hover:bg-purple-700 focus:ring-4 focus:ring-purple-200 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:text-white  dark:focus:ring-purple-900">Get started</a>
                                    </div>
                                </a>
                            </div>
                        </div>

                    </div>
                </div>
            </section>
            {/* <!-- End block --> */}



            <section className='bg-gray-50 dark:bg-gray-900'>
                <div className=" bg-gray-50 container-xxl fact py-5" data-aos="fade-up">
                    <Container className="py-5 px-lg-5">
                        <Row className="g-4">
                            {/* Years Experience */}
                            <Col md={6} lg={3} className="text-center" data-aos="fade-up" data-aos-delay="100">
                                <PeopleAltIcon sx={{ fontSize: 68, color: "gold", marginBottom: 2 }} />
                                <h1 id="count" className="text-white mb-2 font-bold">
                                    <CountUp end={100} duration={3} />K
                                </h1>
                                <p id="PText" className="text-white mb-0">Years Experience</p>
                            </Col>

                            {/* Team Members */}
                            <Col md={6} lg={3} className="text-center" data-aos="fade-up" data-aos-delay="300">
                                <PeopleAltIcon sx={{ fontSize: 68, color: "gold", marginBottom: 2 }} />
                                <h1 id="count" className="text-white mb-2 font-bold">
                                    <CountUp end={100} duration={3} />K
                                </h1>
                                <p id="PText" className="text-white mb-0">Team Members</p>
                            </Col>

                            {/* Satisfied Clients */}
                            <Col md={6} lg={3} className="text-center" data-aos="fade-up" data-aos-delay="500">
                                {/* <i className="fa fa-users fa-3x text-secondary mb-3"></i> */}
                                {/* <img src={PeopleAltIcon} alt="cust" /> */}
                                <PeopleAltIcon sx={{ fontSize: 68, color: "gold", marginBottom: 2 }} />
                                <h1 id="count" className="text-white mb-2 font-bold">
                                    <CountUp end={100} duration={3} />K
                                </h1>
                                <p id="PText" className="text-white mb-0">Satisfied Clients</p>
                            </Col>

                            {/* Completed Projects */}
                            <Col md={6} lg={3} className="text-center" data-aos="fade-up" data-aos-delay="700">
                                <PeopleAltIcon sx={{ fontSize: 68, color: "gold", marginBottom: 2 }} />
                                <h1 id="count" className="text-white mb-2 font-bold">
                                    <CountUp end={100} duration={3} />K
                                </h1>
                                <p id="PText" className="text-white mb-0">Completed Projects</p>
                            </Col>
                        </Row>
                    </Container>
                </div>
            </section>



        </div>
    )
}
